import axios from "axios";

// Create an Axios instance
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

// helper to send you a notification
async function notifyByEmail(comment) {
    try {
        // Fetch project details to get the title
        const projectResp = await apiClient.get(`/projects/${comment.project_id}`);
        const projectTitle = projectResp.data.title;

        await apiClient.post("/notifications/email", {
            to: "adembessam@gmail.com",
            subject: `🆕 New comment from ${comment.author}`,
            body: `Project "${projectTitle}" got a comment:\n\n"${comment.content}"`,
        });
    } catch (err) {
        console.error("Email notification failed:", err);
    }
}


export const fetchComments = async (projectId) => {
    try {
        const response = await apiClient.get(`/comments/project/${projectId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching comments:", error);
        throw error;
    }
};

// Fetch all comments (including unapproved ones)
export const fetchAllComments = async (token) => {
    try {
        const response = await apiClient.get("/comments", {
            headers: { Authorization: `Bearer ${token}` }, // Use the token passed as an argument
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching comments:", error);
        throw error;
    }
};

export const addComment = async (comment) => {
    // 1) Save it
    const resp = await apiClient.post("/comments", comment);
    // 2) Fire off email in background
    notifyByEmail(resp.data).catch(() => { });
    return resp.data;
};

export const approveComment = async (commentId, token) => {
    try {
        const response = await apiClient.put(`/comments/${commentId}/approve`, {}, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (error) {
        console.error("Error approving comment:", error);
        throw error;
    }
};

export const deleteComment = async (commentId, token) => {
    try {
        const response = await apiClient.delete(`/comments/${commentId}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting comment:", error);
        throw error;
    }
};